/**
 * German (Deutsch) translations
 */

const de = {
  nav: {
    home: "Startseite",
    gallery: "Galerie",
    about: "Über uns",
    contact: "Kontakt",
    cart: "Warenkorb",
  },

  home: {
    heroTitle: "Kunst, die die\nSeele berührt",
    heroSubtitle: "Eine kuratierte Sammlung von Originalwerken zeitgenössischer Künstler aus aller Welt.",
    heroCta: "Galerie erkunden",
    heroSecondary: "Unsere Künstler",
    featuredTitle: "Ausgewählte Werke",
    featuredSubtitle: "Handverlesen von unseren Kuratoren",
    categoriesTitle: "Nach Kategorie stöbern",
    newsletterTitle: "Immer auf dem Laufenden",
    newsletterSubtitle: "Neuankömmlinge, Künstlergeschichten und exklusive Vorschauen — direkt in Ihr Postfach.",
    newsletterPlaceholder: "Ihre E-Mail-Adresse",
    newsletterCta: "Abonnieren",
  },

  gallery: {
    title: "Die Sammlung",
    subtitle: "{{count}} Werke verfügbar",
    filterAll: "Alle",
    sortLabel: "Sortieren nach",
    sortNewest: "Neueste zuerst",
    sortPriceAsc: "Preis: aufsteigend",
    sortPriceDesc: "Preis: absteigend",
    sortTitle: "Titel A–Z",
    noResults: "Keine Werke entsprechen Ihren Filtern.",
    clearFilters: "Filter zurücksetzen",
  },

  artwork: {
    by: "von",
    category: "Kategorie",
    medium: "Technik",
    dimensions: "Maße",
    year: "Jahr",
    addToCart: "In den Warenkorb",
    buyNow: "Jetzt kaufen",
    soldOut: "Verkauft",
    reserved: "Reserviert",
    shareWork: "Dieses Werk teilen",
    relatedTitle: "Das könnte Ihnen gefallen",
  },

  cart: {
    title: "Ihr Warenkorb",
    empty: "Ihr Warenkorb ist leer.",
    browseCta: "Galerie durchstöbern",
    remove: "Entfernen",
    quantity: "Menge",
    subtotal: "Zwischensumme",
    shipping: "Versand",
    shippingFree: "Wird an der Kasse berechnet",
    total: "Gesamt",
    checkoutCta: "Zur Kasse",
    continueShopping: "Weiter einkaufen",
  },

  checkout: {
    title: "Kasse",
    stepShipping: "Versand",
    stepPayment: "Zahlung",
    stepConfirm: "Bestätigung",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail-Adresse",
    phone: "Telefonnummer",
    address: "Straße und Hausnummer",
    city: "Stadt",
    postalCode: "Postleitzahl",
    country: "Land",
    cardDetails: "Kartendaten",
    orderSummary: "Bestellübersicht",
    placeOrder: "Bestellung aufgeben",
    processing: "Wird verarbeitet…",
    successTitle: "Bestellung bestätigt!",
    successMessage: "Vielen Dank für Ihren Kauf. Sie erhalten in Kürze eine Bestätigungs-E-Mail.",
    backToGallery: "Zurück zur Galerie",
  },

  about: {
    title: "Über Artelier",
    subtitle: "Wo Kunst ihr Zuhause findet.",
    missionTitle: "Unsere Mission",
    missionText:
      "Artelier wurde mit einem einzigen Zweck gegründet: Sammler mit Originalwerken zu verbinden, die echte Bedeutung tragen. Wir arbeiten mit aufstrebenden und etablierten Künstlern zusammen, um ihre Vision direkt zu Ihnen zu bringen.",
    valuesTitle: "Wofür wir stehen",
  },

  contact: {
    title: "Kontakt aufnehmen",
    subtitle: "Wir freuen uns von Ihnen zu hören.",
    namePlaceholder: "Ihr Name",
    emailPlaceholder: "Ihre E-Mail",
    messagePlaceholder: "Ihre Nachricht",
    sendCta: "Nachricht senden",
    sent: "Nachricht gesendet — wir melden uns bald.",
    addressTitle: "Besuchen Sie uns",
    address: "Maximilianstraße 12\n80539 München, Deutschland",
    emailTitle: "E-Mail",
    emailValue: "hello@artelier.gallery",
    hoursTitle: "Öffnungszeiten",
    hours: "Di – Sa: 10:00 – 18:00\nSo: 12:00 – 17:00",
  },

  common: {
    loading: "Laden…",
    error: "Etwas ist schiefgelaufen.",
    backButton: "Zurück",
    learnMore: "Mehr erfahren",
    viewAll: "Alle ansehen",
    close: "Schließen",
    currency: "€",
  },
};

export default de;
